/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramSettingsDto
 */
export interface ProgramSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramSettingsDto
     */
    healthCheckCron?: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramSettingsDto
     */
    fiscalYearStartMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSettingsDto
     */
    autoArchiveDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramSettingsDto
     */
    snapshotOnBoardReport?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProgramSettingsDto
     */
    riskThresholds?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramSettingsDto
     */
    drivenByTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProgramSettingsDto
     */
    quickBaselineSchemaSlug?: string;
}

/**
 * Check if a given object implements the ProgramSettingsDto interface.
 */
export function instanceOfProgramSettingsDto(value: object): value is ProgramSettingsDto {
    return true;
}

export function ProgramSettingsDtoFromJSON(json: any): ProgramSettingsDto {
    return ProgramSettingsDtoFromJSONTyped(json, false);
}

export function ProgramSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramSettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'healthCheckCron': json['healthCheckCron'] == null ? undefined : json['healthCheckCron'],
        'fiscalYearStartMonth': json['fiscalYearStartMonth'] == null ? undefined : json['fiscalYearStartMonth'],
        'autoArchiveDays': json['autoArchiveDays'] == null ? undefined : json['autoArchiveDays'],
        'snapshotOnBoardReport': json['snapshotOnBoardReport'] == null ? undefined : json['snapshotOnBoardReport'],
        'riskThresholds': json['riskThresholds'] == null ? undefined : json['riskThresholds'],
        'drivenByTags': json['drivenByTags'] == null ? undefined : json['drivenByTags'],
        'quickBaselineSchemaSlug': json['quickBaselineSchemaSlug'] == null ? undefined : json['quickBaselineSchemaSlug'],
    };
}

export function ProgramSettingsDtoToJSON(json: any): ProgramSettingsDto {
    return ProgramSettingsDtoToJSONTyped(json, false);
}

export function ProgramSettingsDtoToJSONTyped(value?: ProgramSettingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthCheckCron': value['healthCheckCron'],
        'fiscalYearStartMonth': value['fiscalYearStartMonth'],
        'autoArchiveDays': value['autoArchiveDays'],
        'snapshotOnBoardReport': value['snapshotOnBoardReport'],
        'riskThresholds': value['riskThresholds'],
        'drivenByTags': value['drivenByTags'],
        'quickBaselineSchemaSlug': value['quickBaselineSchemaSlug'],
    };
}

